import { EmailFormParams } from "../../../types/login";
import { FormValidationConfig } from "../Form.types";
import { createEmailRule } from "../Form.validators";

export const createEmailFormValidation =
  (): FormValidationConfig<EmailFormParams> => ({
    email: {
      required: true,
      requiredMessage: "Email is required",
      rules: [createEmailRule()],
    },
  });
